import { BreakpointObserver } from '@angular/cdk/layout';
import {
    Component,
    computed,
    effect,
    inject,
    Input,
    Signal,
    signal,
    WritableSignal
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { paginate } from '@netwealth/nw-utils';
import { map, Observable } from 'rxjs';
import { OutlineButtonComponent } from '../../../button/button.component';
import { IconComponent } from '../../../icon/icon.component';
import { PillComponent } from '../../../pill/pill.component';
import { MediaArticleCardComponent } from './components/media-article-card/media-article-card.component';
import { MediaArticle } from './models/media-article.model';

@Component({
    selector: 'nw-media-articles-carousel-block',
    imports: [
        OutlineButtonComponent,
        IconComponent,
        PillComponent,
        MediaArticleCardComponent
    ],
    templateUrl: './media-articles-carousel-block.component.html',
    styleUrl: './media-articles-carousel-block.component.scss'
})
export class MediaArticlesCarouselBlockComponent {
    @Input() title?: string;

    public selectedIndex$$: WritableSignal<number> = signal(0);

    private items$$: WritableSignal<MediaArticle[]> = signal([]);

    public get items(): MediaArticle[] {
        return this.items$$();
    }

    @Input() public set items(value: MediaArticle[] | undefined) {
        this.items$$.set(value ?? []);
    }
    private breakpointObserver: BreakpointObserver = inject(BreakpointObserver);
    private gridSize$: Observable<1 | 3> = this.breakpointObserver
        .observe(['(max-width: 767px)', '(min-width: 768px)'])
        .pipe(map((state) => (state.breakpoints['(min-width: 768px)'] ? 3 : 1)));
    private gridSize$$: Signal<1 | 3> = toSignal(this.gridSize$, {
        initialValue: 3 as 1 | 3
    });

    public pages$$: Signal<MediaArticle[][]> = computed(() => {
        const items = this.items$$();
        return items.length > 3
            ? paginate<MediaArticle>(items, this.gridSize$$())
            : [items];
    });
    public showPagination$$: Signal<boolean> = computed(() => this.pages$$().length > 1);

    constructor() {
        effect(() => {
            this.pages$$();
            this.changePage(0);
        });
    }

    public changePage(index: number, $event?: Event): void {
        $event?.preventDefault();
        $event?.stopImmediatePropagation();

        if (index < 0) index = this.pages$$().length - 1;
        if (index > this.pages$$().length - 1) index = 0;

        this.selectedIndex$$.set(index);
    }
}
